import { render, staticRenderFns } from "./EditProductGroupModal.vue?vue&type=template&id=4edfe318&scoped=true"
import script from "./EditProductGroupModal.vue?vue&type=script&lang=js"
export * from "./EditProductGroupModal.vue?vue&type=script&lang=js"
import style0 from "./EditProductGroupModal.vue?vue&type=style&index=0&id=4edfe318&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4edfe318",
  null
  
)

export default component.exports